const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

export default removeNonNumeric;
